<template>
  <div class="bom__wrapper">
    <div class="bom__heading" @click="tempToggleBomBody">
      <div class="bom__headingText">Bill of Materials</div>
      <div class="material-icons" :class="{ bom__iconHidden: !isOpen }">
        add
      </div>
      <div class="material-icons" :class="{ bom__iconHidden: isOpen }">
        remove
      </div>
    </div>
    <TransitionSlide>
      <div v-if="getIsOpen" class="bom__body">
        <div v-if="billOfMaterialsParts">
          <BillOfMaterialsItem
            v-for="item in getDuplicateParts"
            :key="item.PartName"
            :item="item"
            :deviceType="deviceType"
          />
        </div>
        <div v-if="getBomItemsExist">
          <BillOfMaterialsItem
            v-for="item in getBOMList"
            :key="item.PartName"
            :item="item"
            :deviceType="deviceType"
          />
        </div>
        <div v-if="getShowPleaseSelectOptionsMsg" class="bom__noBom">
          Please select options
        </div>
        <!-- Hide Notes section in BOM until we can connect to SAP post-launch -->
        <!-- <div class="bom__note">
          <div
            v-if="getBomItemsExist"
            class="bom__noteHeading"
            @click="toggleNote"
          >
            ADD A NOTE +
          </div>
          <TransitionSlide>
            <textarea
              v-if="getBomNoteIsOpen"
              class="bom__noteTextArea"
              :maxlength="noteMaxLength"
              @input="updateNote"
              :v-html="bomNoteText"
            />
          </TransitionSlide>
        </div> -->
      </div>
    </TransitionSlide>
  </div>
</template>

<script>
import BillOfMaterialsItem from "./BillOfMaterialsItem";
import TransitionSlide from "../../shared/transitions/TransitionSlide";
import { mapGetters, mapState } from "vuex";
// import { _ } from "vue-underscore";

export default {
  props: {
    deviceType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapState("enhancedBom", [
      "bomNoteText",
      "billOfMaterialsParts",
      "hasFinishedBeenClicked",
      "getUserHasSelectedOptions"
    ]),
    ...mapGetters("enhancedBom", [
      "getIsOpen",
      "getBomItemsExist",
      "getBomNoteIsOpen",
      "getBillOfMaterials",
      "getBomParts",
      "getShowPleaseSelectOptionsMsg",
      "getDuplicateParts"
    ]),
    isOpenIcon() {
      return this.getIsOpen ? "remove" : "add";
    },
    noteMaxLength() {
      return 1000;
    },
    getBOMList() {
      const bom = this.getBillOfMaterials.BOM;
      // NOTE: this logic excludes IsProductVariant from the array until user clicks I'm finished button
      const bomListVariantFilteredIfFinishedBtnIsNotClicked = bom.filter(
        item => {
          if (true == this.hasFinishedBeenClicked) {
            return true;
          }
          return true !== item.IsProductVariant;
        }
      );
      return bomListVariantFilteredIfFinishedBtnIsNotClicked;
    }
  },
  methods: {
    tempToggleBomBody() {
      this.$store.dispatch("enhancedBom/toggleIsOpen");
      this.isOpen = !this.isOpen;
    },
    toggleNote() {
      this.$store.dispatch("enhancedBom/toggleBomNoteIsOpen");
    },
    updateNote(event) {
      this.$store.dispatch("enhancedBom/updateBomNoteText", event.target.value);
    }
  },
  components: {
    BillOfMaterialsItem,
    TransitionSlide
  }
};
</script>

<style lang="scss" scoped>
.bom {
  &__wrapper {
    width: 100%;
    border: 1px solid rgb(216, 216, 216);
    border-radius: 0px;
    margin-top: 30px;
    font-family: $font-family-sans-serif-regular;
  }

  &__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 49px;
    background: rgba(37, 192, 208, 0.15);
    border-radius: 0px;
    padding: 0 10px 0 10px;
    cursor: pointer;
    user-select: none;
  }

  &__iconHidden {
    display: none;
  }

  &__headingText {
    color: rgb(51, 51, 51);
    font-size: 24px;
    letter-spacing: 0.75px;
  }
  &__body {
    padding: 0 10px;
  }
  &__noBom {
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 21px;
    padding: 20px 0;
    text-align: left;
  }
  &__noteHeading {
    font-size: 16px;
    color: rgb(37, 192, 208);
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    margin-bottom: 10px;
    text-align: left;
  }
  &__noteTextArea {
    width: 100%;
    height: 230px;
    border: 1px solid rgb(216, 216, 216);
    border-radius: 0px;
    resize: none;
    margin-bottom: 20px;
    padding: 10px;
  }
}
</style>
